import { render, staticRenderFns } from "./EditPassDialog.vue?vue&type=template&id=1da333e3&"
import script from "./EditPassDialog.vue?vue&type=script&lang=js&"
export * from "./EditPassDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports